import { AppConfiguration } from "@puntaje/shared/core"
import { BaseConfig } from "./base.config"

export const config: AppConfiguration = new BaseConfig()
